'use client'

import CustomerQuote from '@/components/CustomerQuote'

const LogixboardCustomerQuote2 = () => (
    <CustomerQuote
        sx={{
            height: {
                xs: `792px`,
                sm: `792px`,
                md: `480px`,
                lg: `480px`,
                xl: `480px`,
            },
        }}
        light={false}
        backgroundImageSrc={'/images/ets-maps/ets-explorer-desktop-12.png'}
        mobileBackgroundImageSrc={'/images/ets-maps/ets-explorer-mobile-3.png'}
        text={
            <>
                “Lune was the best partner for translating detailed information into something
                understandable. Instead of just presenting all of the data and hoping someone can
                make sense of it, the Lune team knew how to curate the data and make it
                understandable to people.”
            </>
        }
        avatar={{
            title: 'Erin Miska',
            subtitle: 'Product Marketing Manager at Logixboard',
            imageSrc: '/images/logixboard-case-study/erin-miska.png',
        }}
        reversedOnMobile
    />
)

export default LogixboardCustomerQuote2
